import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1108Model } from './kymw1108.model';
import { GetEbaseCandidateListService } from './api-service/get-ebase-candidate-list.service';
import { KYMW1108InputModel } from './vo/kymw1108-input.model';
import { KYMW1108OutputModel } from './vo/kymw1108-output.model';

import type { GoodsInfo } from './vo/good-info.model';

@Component({
  selector: 'app-kymw1108',
  templateUrl: 'kymw1108.component.html',
  styleUrls: ['kymw1108.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1108Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  model = new KYMW1108Model();
  setKYMW1108Parameter: Function;
  input: KYMW1108InputModel;

  @ViewChild('dtg_CurrentSelectableEBaseGoodsInfo', { static: true }) dtg_CurrentSelectableEBaseGoodsInfo: FlexGrid;
  @ViewChild('dtg_CurrentCandidateGoodsInfoList', { static: true }) dtg_CurrentCandidateGoodsInfoList: FlexGrid;

  constructor(
    private kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getEbaseCandidateListService: GetEbaseCandidateListService,
  ) {
    super(kymw00Model);
  }

  ngOnInit() {
    this.setPageView(0);
  }

  ngAfterViewInit() {
    this.dtg_CurrentCandidateGoodsInfoList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_CurrentCandidateGoodsInfoList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_goods_info_${ht.row}`).click();
      }
    });
  }

  clearInput() {
    this.input = {
      processFlag: "2",
      newGoodsNum: 0,
      updateSingleGoodsNum: 0,
      selectableGoodsNum: 0,
      selectableEBaseGoodsList: [],
    }
  }

  /** ダイアログ入力項目をセット */
  setInterfaceParam(input: KYMW1108InputModel) {
    this.input = input;
  }

  eventPrevButton_CLICKHandler() {
    const currentIndex = this.model.currentIndex;
    const selectedList = this.model.currentCandidateGoodsInfoList.filter(ietm => ietm.checked);
    if (selectedList.length > 0) {
      // 前頁に戻る
      if (currentIndex > 0) {
        this.setPageView(currentIndex - 1);
      }
    } else {
      // エラーメッセージ「取込先商品を1件以上選択してください。」
      this.dialogService.openAlertGetMessage('W0055');
    }
  }

  eventNextButton_CLICKHandler() {
    const currentIndex = this.model.currentIndex;
    const selectedList = this.model.currentCandidateGoodsInfoList.filter(ietm => ietm.checked);
    if (selectedList.length > 0) {
      // 次頁に行く
      if (currentIndex < this.input.selectableEBaseGoodsList.length - 1) {
        this.setPageView(currentIndex + 1);
      }
    } else {
      // エラーメッセージ「取込先商品を1件以上選択してください。」
      this.dialogService.openAlertGetMessage('W0055');
    }
  }

  // ダイアログ「閉じる」アイコンボタン押下時処理
  eventClose_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0191', [''], // 確認メッセージ「eBASE取込を中止しますか。」
      (closeDetail) => {
        // はいを押下した場合、ダイアログを閉じる
        if (closeDetail === PlessAlert.Yes) {
          this.closeWindow(true);
        }
      }
    );
  }

  // チェックボックス クリック時処理
  eventCheckbox_CLICKHandler(): void {
    // 現在のJANコードと選択されたデータのマッピングを保持する
    const selectedList = this.model.currentCandidateGoodsInfoList.filter(ietm => ietm.checked);
    if (selectedList.length > 0) {
      this.model.selectedGoodsInfoListByJanCode.set(
        this.model.currentSelectableEBaseGoodsInfo.janCode,
        selectedList,
      );
    } else {
      this.model.selectedGoodsInfoListByJanCode.delete(
        this.model.currentSelectableEBaseGoodsInfo.janCode,
      );
    }

    // 全対象件数
    const targetCount = this.input.selectableEBaseGoodsList.length;
    // 選択済み対象件数
    const selectedMap = this.model.selectedGoodsInfoListByJanCode;
    let selectedCount = selectedMap.size;
    // 未チェックの選択対象があった場合は「取込」ボタン非活性
    this.model.isDesabledImportButton = !(selectedCount === targetCount);
  }

  // 「取込」ボタン クリック時処理
  eventImport_CLICKHandler() {
    // 出力対象を抽出
    const outputGoodsInfoList = [] as GoodsInfo[];
    const selectedMap = this.model.selectedGoodsInfoListByJanCode;
    for (const janCode of selectedMap.keys()) {
      const selectedGoodsInfoList = selectedMap.get(janCode);
      if (selectedGoodsInfoList) {
        outputGoodsInfoList.push(...selectedGoodsInfoList);
      }
    }

    // 出力
    const output = new KYMW1108OutputModel();
    output.selectedGoodsInfoList = outputGoodsInfoList;
    this.setKYMW1108Parameter(output);
    // ダイアログを閉じる
    this.closeWindow();
  }
  
  pagerDisplayLabel() {
    const listCount = this.input.selectableEBaseGoodsList.length;
    const currentPageNumber = this.model.currentIndex + 1;
    return `${listCount} 件中 ${currentPageNumber} 件目表示`;
  }

  /** 各一覧データから画面に表示する対象をセット */
  private setPageView(pageIndex: number) {
    const targetList = this.input.selectableEBaseGoodsList;

    if (0 <= pageIndex && pageIndex < targetList.length) {
      this.model.currentIndex = pageIndex;
      const targetInfo = targetList[pageIndex];

      // 取込先選択対象 eBASE取込データ をセット
      this.model.currentSelectableEBaseGoodsInfo = targetInfo;

      // 選択済み商品候補の判定用
      const selectedItemList = [] as { pCode: string; itemCode: string }[]; // 商品は Pコード&アイテムコード で一意となる
      const selectedMap = this.model.selectedGoodsInfoListByJanCode;
      const selectedGoodsInfoList = selectedMap.get(targetInfo.janCode);
      if (selectedGoodsInfoList) {
        for (const info of selectedGoodsInfoList) {
          selectedItemList.push({ pCode: info.pCode, itemCode: info.itemCode });
        }
      }

      // eBASE 取込商品候補一覧取得
      this.getEbaseCandidateListService.execute(this.model, targetInfo.janCode, (response) => {
        this.model.currentCandidateGoodsInfoList = response.GoodInfoList.map(_ => ({
          checked: selectedItemList.some(item => (item.pCode === _.PCode) && (item.itemCode === _.ItemCode)), // 選択済みのデータならフラグを立てる
          pCode: _.PCode,
          itemCode: _.ItemCode,
          janCode: _.JanCode,
          goodsName: _.GoodsName,
          standardName: _.StandardName,
          containNum: Number(_.ContainNum),
          eBaseSpecCode: _.EBaseSpecCode,
          updateDate: _.UpdateDate,
        } as GoodsInfo));
      });
    }
  }

  // ダイアログを閉じる
  private closeWindow(isCanceled = false): void {
    // 入力モデルをクリア
    this.clearInput();
    // 自画面を閉じる
    this.closeFunction(isCanceled);
  }

}
